import { Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';

export const ListSection = ({ section }: { section: DashboardSection }) => (
  <Flex direction="column" gap="4px">
    {(section.items ?? []).map((item, i) => (
      <Flex key={item} gap="8px" align="baseline">
        <Text variant="p">{i + 1}.</Text>
        <Text variant="p">{item}</Text>
      </Flex>
    ))}
  </Flex>
);
